var map = {
	"./service_1.jpeg": 6038,
	"./service_2.jpeg": 5195,
	"./service_3.jpeg": 1344,
	"./service_4.jpeg": 9057,
	"./service_5.jpeg": 7493,
	"./service_6.jpeg": 8063,
	"./service_7.jpeg": 5941,
	"./service_8.jpeg": 2304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 270;